import { MenuIdInsight } from '@jira/navigation-apps__constants/src/MenuIdInsight.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { servicedeskCmdbInsightRoute } from '@jira/router-routes__servicedesk-cmdb-routes/src/servicedeskCmdbInsightRoute.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import { getCmdbResources } from './common/getCmdbResources.tsx';
import LandingPage, { LazyServicedeskCmdbLandingPage } from './ui/landing-page/index.tsx';
import { AssetsAppRedirect } from './ui/redirect/assets-app-redirect/index.tsx';

export const servicedeskCmdbInsightRouteEntry: Route = createEntry(
	servicedeskCmdbInsightRoute,
	() => ({
		group: 'servicedesk',
		layout: globalLayout,
		navigation: { menuId: MenuIdInsight },
		// eslint-disable-next-line no-restricted-syntax
		component: fg('assets_as_an_app_v2') ? AssetsAppRedirect : LandingPage,
		resources: getCmdbResources(),
		forPaint: [LazyAtlassianNavigation, LazyServicedeskCmdbLandingPage],
		perfMetricKey: 'service-management.insight-cmdb.interact-with-landing-page',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
